module.exports = __webpack_public_path__ + "img/datadock.ee9e3b44.png";